var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSampleCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2550_21245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 48,
    height: 48,
    rx: 15,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 3.75,
    width: 46.5,
    height: 46.5,
    rx: 14.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 37H19C18.4 37 18 36.6 18 36V22.6C18 21.2 19 20 20.3 19.7L27.7 18C28 17.9 28.3 18 28.5 18.2C28.7 18.4 28.9 18.7 28.9 19V36C29 36.5 28.6 37 28 37ZM20 35H27V20.2L20.8 21.6C20.3 21.7 20 22.1 20 22.6V35Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37H29C28.4 37 28 36.6 28 36V21C28 20.7 28.1 20.4 28.4 20.2C28.6 20 29 19.9 29.3 20L35.8 21.6C37.1 21.9 38.1 23.1 38.1 24.5V35.9C38 36.5 37.6 37 37 37ZM30 35H36V24.6C36 24.1 35.7 23.7 35.2 23.6L30 22.3V35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26H32C31.4 26 31 25.6 31 25C31 24.4 31.4 24 32 24H34C34.6 24 35 24.4 35 25C35 25.6 34.6 26 34 26Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9996 29H32.0996C31.4996 29 31.0996 28.6 31.0996 28C31.0996 27.4 31.4996 27 32.0996 27H33.9996C34.5996 27 34.9996 27.4 34.9996 28C34.9996 28.6 34.5996 29 33.9996 29Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 32H32C31.4 32 31 31.6 31 31C31 30.4 31.4 30 32 30H34C34.6 30 35 30.4 35 31C35 31.6 34.6 32 34 32Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37H23C22.4 37 22 36.6 22 36V33C22 32.4 22.4 32 23 32H24C24.6 32 25 32.4 25 33V36C25 36.5 24.6 37 24 37Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 2,
    height: 2,
    rx: 1,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2550_21245",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2550_21245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2550_21245",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleCompany);
export default __webpack_public_path__ + "static/media/sample-company.8a1eee17c620e3ba310f345ead04e0aa.svg";
export { ForwardRef as ReactComponent };